import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { pure } from 'recompose'
import moment from 'moment'
import { API_HOST } from './../config'


const loadPros = async () => {
    return fetch(`${API_HOST}/pros`)
        .then(res => res.json())
}


class Pros extends Component{

    constructor(props){
        super(props)
        this.state = {
            loading: true,
            error: false,
            pros: []
        }
    }

    async componentDidMount() {
        try {
            const pros = await loadPros()
            this.setState({
                pros: pros,
                error: false,
                loading: false,
            })


        } catch (error) {
            this.setState({
                pros: [],
                error: true,
                loading: false,
            })
        }
    }
    
    render(){
        const { loading, pros = [] } = this.state
        
        if (loading){
            return loading && <p className="text--loading">Loading</p>
        }

        return (
            <table className="list--pros">
                <thead>
                    <tr>

                        <th></th>
                        <th>Pro</th>
                        <th>Email</th>
                        <th>Dashboard</th>
                        <th>Calendar</th>
                        <th>Created at</th>
                    </tr>
                </thead>
                <tbody>
                {
                    pros.map((p, i) => {
                        return (
                            <tr key={p.id}>
                                <td>{ i+1 }</td>
                                <td>
                                    <Link to={`/pro/${p.id}`}>{p.firstname} {p.lastname}</Link>
                                </td>
                                <td>
                                    {p.email}
                                </td>
                                <td>
                                    {p.dashboard.toString()}
                                </td>
                                <td>
                                    {p.calendar.toString()}
                                </td>
                                <td>
                                    {moment(p.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                                </td>
                            </tr>
                            )}
                    )
                }
                </tbody>   
            </table>
        )    
    }
}

export default pure(Pros)


// WEBPACK FOOTER //
// ./src/pages/Pros.js